import * as ActionTypes from "../ActionTypes";

const initialState = {
  hydrated: false,
};
export default function BulkUploadReducer(state, action) {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  switch (action.type) {
    case ActionTypes.GET_CAMPAIGN_FILES_DATA:
      return {
        ...state,
        campaignUplodedFiles: action.payload.data,
      };
    case ActionTypes.SET_BULK_STATE_PARAMS:
      return {
        ...state,
        [action.payload.type]: action.payload.data,
      };
    case ActionTypes.GET_PROSPECT_FILES_DATA:
      return {
        ...state,
        prospectUplodedFiles: action.payload.data,
      };
    case ActionTypes.LOAD_CAMPAIGN_FILEDATA:
      let campaignBulkfilerecords = action.payload.data || [];
      campaignBulkfilerecords.forEach((object, index) => {
        object.identifier = index;
        object.saveCampaign = false;
      });
      return {
        ...state,
        campaignBulkfilerecords,
      };
    case ActionTypes.LOAD_PROSPECT_FILEDATA:
      let prospectBulkfilerecords = action.payload.data || [];
      prospectBulkfilerecords.forEach((object, index) => {
        object.identifier = index;
        object.saveProspect = false;
        object.saveDemographics = false;
      });
      return {
        ...state,
        prospectBulkfilerecords,
      };
    default:
      return state;
  }
}
